import { Tournament } from "../interfaces/tournament";

export const getTournamentFormat = (tournament: Tournament) => {
  if (tournament.type === "LG") return "Liga";
  if (tournament.type === "CP") return "Copa";
  if (tournament.type === "MX") return "Mixto";
  return "";
};